import React from 'react'
import { render } from 'react-dom'
import App from './src/app.js'

const root = document.querySelector('#root')

render(<App />, root)
